
import { default as GHPlane } from './GHPlane';

const constructPlane = (a = new THREE.Vector3(0, 0, 0), b = new THREE.Vector3(1, 0, 0), c = new THREE.Vector3(0, 1, 0), name = 'default plane') => {
  let center = a;
  let xAxis = b.clone().normalize();
  let normal = (new THREE.Vector3()).crossVectors(b.clone().normalize(), c.clone().normalize()).normalize();

  let rot = new THREE.Quaternion();
  rot.setFromAxisAngle(normal, Math.PI * 0.5);
  let yAxis = xAxis.clone().applyQuaternion(rot);

  let plane = new GHPlane(center, xAxis, yAxis);
  plane.normal = normal;
  plane.name = name;

  return plane;
};

const XYPlane = () => {
  return constructPlane(
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(1, 0, 0),
    new THREE.Vector3(0, 1, 0),
    'XY'
  );
};

const XZPlane = () => {
  return constructPlane(
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(1, 0, 0),
    new THREE.Vector3(0, 0, 1),
    'XZ'
  );
};

const YZPlane = () => {
  return constructPlane(
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0, 1, 0),
    new THREE.Vector3(0, 0, 1),
    'YZ'
  );
};

const isClockwise = (path) => {
  let total = 0.0;

  let n = path.length;
  for (let i = 0; i < n; i++) {
    var pt1 = path[i];
    var pt2 = path[(i + 1) % n];
    total += (pt2.X - pt1.X) * (pt2.Y + pt1.Y);
  }

  return (total > 0);
};

export { default as GHSegment } from './GHSegment';
export { default as XorShift } from './XorShift';

export {
  GHPlane,
  XYPlane,
  XZPlane,
  YZPlane,
  constructPlane,
  isClockwise
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/math/index.js